var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93335 15.6C6.20002 15.6 3.93335 13.3333 3.93335 10.6V8.33329C3.93335 7.93329 4.20002 7.66663 4.60002 7.66663C5.00002 7.66663 5.26668 7.93329 5.26668 8.33329V10.6C5.26668 12.6 6.93335 14.2666 8.93335 14.2666C10.9333 14.2666 12.6 12.6 12.6 10.6V9.79996C12.6 9.39996 12.8667 9.13329 13.2667 9.13329C13.6667 9.13329 13.9333 9.39996 13.9333 9.79996V10.6C13.9333 13.3333 11.7333 15.6 8.93335 15.6Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00008 8.53329C2.86675 8.53329 2.80008 8.53329 2.66675 8.46663C1.40008 7.73329 0.666748 6.46663 0.666748 4.99996V1.33329C0.666748 0.933293 0.933415 0.666626 1.33341 0.666626H3.13341C3.53341 0.666626 3.80008 0.933293 3.80008 1.33329C3.80008 1.73329 3.53341 1.99996 3.13341 1.99996H2.00008V4.99996C2.00008 5.93329 2.53341 6.79996 3.33341 7.26663C3.66675 7.46663 3.73341 7.86663 3.60008 8.19996C3.46675 8.39996 3.26675 8.53329 3.00008 8.53329Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60002 8.93329C4.20002 8.93329 3.93335 8.66662 3.93335 8.26662C3.93335 7.86662 4.20002 7.59996 4.60002 7.59996C6.06668 7.59996 7.20002 6.39996 7.20002 4.99996V1.99996H6.13335C5.73335 1.99996 5.46668 1.73329 5.46668 1.33329C5.46668 0.933293 5.73335 0.666626 6.13335 0.666626H7.93335C8.33335 0.666626 8.60002 0.933293 8.60002 1.33329V4.99996C8.60002 7.19996 6.80002 8.93329 4.60002 8.93329Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2667 10.4668C12 10.4668 10.9333 9.40017 10.9333 8.1335C10.9333 6.86684 12 5.80017 13.2667 5.80017C14.5334 5.80017 15.6 6.86684 15.6 8.1335C15.6 9.40017 14.5334 10.4668 13.2667 10.4668ZM13.2667 7.1335C12.7334 7.1335 12.2667 7.60017 12.2667 8.1335C12.2667 8.66684 12.7334 9.1335 13.2667 9.1335C13.8 9.1335 14.2667 8.66684 14.2667 8.1335C14.2667 7.60017 13.8 7.1335 13.2667 7.1335Z",
    fill: "#6C5DD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9333,
    height: 14.9333,
    fill: "white",
    transform: "translate(0.666748 0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticals);
export default __webpack_public_path__ + "static/media/verticals.e2bb2844c8dceb3104f58af6e46d636e.svg";
export { ForwardRef as ReactComponent };